import React, { Component } from 'react';

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 3
    };
  }

  componentDidMount() {
    this.startCountBack();
  }

  startCountBack = () => {
    let counterInterval = setInterval(() => { 
      let timeToStart = this.state.time;

      timeToStart -= 1;

      if (timeToStart > 0) {
        this.setState({
          time: timeToStart
        });
      } else {
        clearInterval(counterInterval);
        this.props.onCompleted();
      }
    }, 1000);
  }

  render() {
    return (
      <div className="counter">
        <span>{this.state.time}</span>
      </div>
    );
  }
}

export default Counter;